<template>
  <div>
    <!-- <p class="font-weight-bold">
      <ConsoleLink to="/global-variable" class="text-primary">
        {{ $t('sideBar.global_variable') }} >
      </ConsoleLink> Edit {{ $t('sideBar.global_variable') }}
    </p> -->

    <a-breadcrumb separator=">">
      <a-breadcrumb-item>
        <ConsoleLink to="/global-variable" class="text-primary">
          {{ $t('sideBar.global_variable') }}
        </ConsoleLink>
      </a-breadcrumb-item>
      <a-breadcrumb-item>
        {{ $t('utils.edit') }} {{ $t('sideBar.global_variable') }}
      </a-breadcrumb-item>
    </a-breadcrumb>

    <FormEditGlobalVariable :permission="permission" />
  </div>
</template>

<script>
import FormEditGlobalVariable from '@/components/Price/Global-Variable/Edit'
import ConsoleLink from '@/components/ConsoleLink/ConsoleLink.vue'

export default {
  components: {
    FormEditGlobalVariable,
    ConsoleLink,
  },
  computed: {
    permission() {
      return this.$store.getters['user/can']('global-variable')
    },
  },
  // watch: {
  //   permission(newValue) {
  //     if(!newValue.length || !newValue.includes('WRITE')) {
  //       this.$router.push({path: '/error/403', query: {...this.$route.query}})
  //     }
  //   },
  // },
}
</script>
